// GET /api/admin/settings (Settings → Automatic reminders), for the card that edits it and for copy that depends on it.
import { useEffect, useState } from 'react';
import type { PortalSettings } from '@upm/domain';
import { api, ApiError } from '../lib/api';

export function usePortalSettings() {
  const [settings, setSettings] = useState<PortalSettings | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    let live = true;
    api.get<PortalSettings>('/api/admin/settings').then(
      (s) => { if (live) setSettings(s); },
      (e) => { if (live) setError(e instanceof ApiError ? e.message : 'Could not load the reminder settings.'); },
    );
    return () => { live = false; };
  }, []);
  return { settings, setSettings, error, setError };
}
